<template>
	<section>
		<!--列表-->
		<el-table :data="reviewWays" highlight-current-row v-loading="listLoading" style="width: 100%;margin-top:20px" border :height="formHeight" size="mini">
			<!-- <el-table-column type="selection" width="55">
			</el-table-column> -->
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="name" label="名称" sortable>
			</el-table-column>
			<el-table-column prop="level" label="等级" >
			</el-table-column>
			<el-table-column prop="remark" label="描述" >
			</el-table-column>
		</el-table>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getReviewWay} from '../../api/api';

	export default {
		data() {
			return {
				reviewWays: [],
                listLoading: false,
                formHeight:0
			}
		},
		methods: {
			//获取因子列表
			getReviewWay() {
				this.listLoading = true;
				getReviewWay({}).then((res) => {
					this.listLoading = false;
					this.reviewWays = res.data.data;
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				this.formHeight=hgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getReviewWay();
		}
	}

</script>
<style>
	#colorUL {
		height: 250px;
	}
	#colorUL li{
		float: left;
		list-style: none;
		width: 20%;
		margin: 5px 0;
	}
	.color{
		float: left;
		width: 60px;
		height: 30px;
		margin-right: 5px;
	}
	#colorUL .colorNum{
		float: left;
		width: 70px;
	}
</style>



// WEBPACK FOOTER //
// ReviewWay.vue?753abfd4